import { Icon, Logo, Spacer, SvgVideoCam, Text } from '@loomhq/lens';
import React from 'react';

import { FadeRoot, FadeText } from 'components/layout/navigation/FadeText';

import styles from './styles.module.less';

export default function PersistentRecordButton({ isCollapsed, onClick }) {
  return (
    <button className={styles.persistentRecordButton} onClick={onClick}>
      <FadeRoot>
        {isCollapsed ? (
          <Icon icon={<SvgVideoCam />} color="currentColor" />
        ) : (
          <Logo variant="symbol" maxWidth={3} symbolColor="currentColor" />
        )}
        <Spacer right="small" />
        <FadeText visible={!isCollapsed}>
          <Text fontWeight="medium">Record a Loom</Text>
        </FadeText>
      </FadeRoot>
    </button>
  );
}
